export default __webpack_public_path__ + "static/media/SWT1370.34I-34996_-24484_0.35bf9142.jpg";